import { eventsSchemaDto } from '@web/common';
import { publicAPI } from '../PublicAPI';

export const getEvents = async () => {
  return publicAPI.get('api/events', eventsSchemaDto, { timeout: 30_000 });
};
